import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import RetryCallbackButton from "../../elements/retryCallbackButton/RetryCallbackButton";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PaymentDetailsContent from "./PaymentDetailsContent";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPaymentDetailsTabsWrapper, StyledPaymentDetailsWrapper } from "../styledPayment";
import { HTTP_STATUSES, PAYMENT_SYSTEM } from "../../../utils/consts";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import queryString from "query-string";
import PaymentLogsContainer from "./PaymentLogsContainer";

const DEFAULT_TAB = "";

const PaymentDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  let [payment, setPayment] = useState(null);

  const [transferUserEmail, setTransferUserEmail] = useState(null);

  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayment = async () => {
    let responsePayment = null;

    await axios.get("/api/payments/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPayment(response.data);

        responsePayment = response.data;
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });

    return responsePayment;
  };

  const fetchTransferDetails = (responsePayment) => {

    if (!responsePayment || responsePayment.paymentSystem.subName !== PAYMENT_SYSTEM.BALANCE_TRANSFER) {
      return;
    }

    axios.get(`/api/transfers?payment.referenceId=${responsePayment.referenceId}`, userAuthenticationConfig()).
      then(response => {
        if (response.status === HTTP_STATUSES.HTTP_OK && response.data["hydra:member"][0]) {
          setTransferUserEmail(response.data["hydra:member"][0]?.payout?.connection?.project?.user?.email);
        }
      }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
      });
  };

  const fetchPaymentTransactionOrPaymentTransfer = () => {
    fetchPayment().then(responsePayment => {
      fetchTransferDetails(responsePayment);
    });
  };

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "systemLogs": {
        return 1;
      }
      case "serviceLogs": {
        return 2;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      if (newValue === "") {
        history.push(`/payments/${payment.id}`);
        return;
      }

      history.push("?currentTab=" + newValue);
    }
  };

  //TODO add pusher
  useEffect(() => {
    fetchPaymentTransactionOrPaymentTransfer();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.paymentTitle")}</title>
        </Helmet>
        <StyledPaymentDetailsWrapper>
          <div className="payment-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
            <RetryCallbackButton
              id={match.params.id}
              type="payments"
              setNotification={setNotification}
              notification={notification}
            />
          </div>
          <StyledPaymentDetailsTabsWrapper>
            <StyledTabsHead className="tab-head">
              <h4 className="tab-head__title">
                {t("tabs.titlePayment")}
              </h4>
              <Tabs
                value={queryParams?.currentTab ?? DEFAULT_TAB}
                indicatorColor="secondary"
                onChange={handleChange}
                orientation="vertical"
                className="tab-head-buttons"
              >
                <Tab label={t("tabs.transactionInfo")} value="" />
                <Tab label={t("tabs.systemLogs")} value="systemLogs" />
                <Tab label={t("tabs.serviceLogs")} value="serviceLogs" />
              </Tabs>
            </StyledTabsHead>
            <StyledTabsBody className="tab-body">
              <TabPanel
                value={tabValue}
                index={0}
              >
                <PaymentDetailsContent
                  payment={payment}
                  transferUserEmail={transferUserEmail}
                />
              </TabPanel>
              <TabPanel
                value={tabValue}
                index={1}
              >
                <PaymentLogsContainer transactionId={match.params.id} type="systemLogs" />
              </TabPanel>
              <TabPanel
                value={tabValue}
                index={2}
              >
                <PaymentLogsContainer transactionId={match.params.id} service={payment?.connection.service.name} type="serviceLogs" />
              </TabPanel>
            </StyledTabsBody>
          </StyledPaymentDetailsTabsWrapper>
        </StyledPaymentDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PaymentDetailsContainer;